var app = angular.module('leonardo');

var CategorySelector = function(AuthDataService, CategoryRestService, $q) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl:  'views/templates/widget/category-selector.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      inline: '@',
      account: '=?',
      sector: '=?',
      onCategoriesLoaded: '&?'
    },
    link: function (scope, element, attrs, ctrls) {

      scope.multiple = attrs.multiple ? true : false;
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];

      scope.categoriesSector = function(categories){
        var categories_valid = [];
        angular.forEach(categories, function (value) {
          if(!scope.sector || value.sector.length < 1 || _.contains(value.sector, scope.sector)) {
            categories_valid.push(value);
          }
        });
        return categories_valid;
      };

      scope.initCategories = function () {
        var defer = $q.defer();
        CategoryRestService.getlist({
          disable_pagination:true,
          summary:true,
          account: scope.account
        }, true).then(function (data) {
          var results = data.results ? data.results : data;
          scope.categories = scope.categoriesSector(results);
          
          // Call the callback function if provided
          if (typeof scope.onCategoriesLoaded === 'function') {
            scope.onCategoriesLoaded({categories: results});
          }
          
          defer.resolve();
        }, function (error) {
          defer.reject(error);
        });
        return defer.promise;
      };

      scope.ngModelCtrl.$render = function() {
        if (scope.multiple) {
          scope.value = angular.isArray(scope.ngModelCtrl.$modelValue) ? scope.ngModelCtrl.$modelValue : [scope.ngModelCtrl.$modelValue];
        }
        else {
          scope.value = angular.isArray(scope.ngModelCtrl.$modelValue) ? scope.ngModelCtrl.$modelValue[0] : scope.ngModelCtrl.$modelValue;
        }
      };

      scope.ngModelCtrl.$validators.required = function(modelValue) {
        if (!scope.required) return true;
        if(modelValue) {
          if (angular.isArray(modelValue))
            return (modelValue.length > 0) ? true : false;
          else
            return !isNull(modelValue) ? true : false;
        }
      };

      scope.toggleCategory = function(category) {
        if (scope.disabled) return;
        var list = angular.copy(scope.value);
        if (scope.multiple) {
          if (!scope.value)
            list = [];
          var index = list.indexOf(category.id);
          if (index >= 0) list.splice(index, 1);
          else list.push(category.id);
        }
        else list = category.id;
        scope.value = list;
      };

      scope.toggleAll = function() {
        if (scope.disabled) return;
        var list = [];
        if (!scope.value || (scope.value.length != scope.categories.length))
          angular.forEach(scope.categories, function(value) {
            list.push(value.id);
          });
        scope.value = list;
      };

      scope.isAllSelected = function() {
        return (scope.value && scope.categories) && (scope.value.length == scope.categories.length);
      };

      scope.isSelected = function(category) {
        if (scope.multiple) {
          return (_.contains(scope.value, category.id));
        }
        else{
          return (category.id == scope.value);
        }
      };

      scope.$on('select-categories:updated', function ($event, categories) {
        var ids = [];
        angular.forEach(categories, function (category) {
          ids.push(category.id ? category.id : category)
        });
        scope.value = ids;
      });

      scope.$watch('[sector, account]', function () {
        scope.initCategories().then(function () {
          var ids = [];
          angular.forEach(scope.categories, function (category) {
            if (scope.multiple) {
              if (_.contains(scope.value, category.id)) {
                ids.push(category.id);
              }
            }
            else {
              if (scope.value == category.id) {
                ids = category.id;
              }
            }
          });
          scope.value = ids;
        });
      });

      scope.$watch('value', function (newValue) {
        scope.ngModelCtrl.$setViewValue(newValue);
      });
    }
  };
};

app.directive('categorySelector', ['AuthDataService', 'CategoryRestService', '$q', CategorySelector]);
